import React from 'react';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/form-base-components/sub-components/character-limit.css';


const CharacterLimit = React.memo(({
  value,
  characterLimit,
}) => {

  const characters = value ? value.length : 0;

  return (
    <div className={`character-limit ${characters > characterLimit ? 'character-limit-overlimit' : ''}`}>
      <p>
        {`Character limit ${characters}/${characterLimit}`}
      </p>
    </div>
  );
});



CharacterLimit.propTypes = {
  value: PropTypes.string,
  characterLimit: PropTypes.number,
};

export { CharacterLimit };
